var map = {
	"./BiCruzfarmaRed": 5120,
	"./BiCruzfarmaRed.vue": 5120,
	"./Dashboard": 5748,
	"./Dashboard.vue": 5748,
	"./Login": 1015,
	"./Login.vue": 1015,
	"./ResetPassword": 9165,
	"./ResetPassword.vue": 9165,
	"./assets/boehringer.png": 6982,
	"./assets/cinfa.png": 1754,
	"./assets/data": 3588,
	"./assets/data.json": 3588,
	"./assets/footer.svg": 1324,
	"./assets/image_banner.png": 2427,
	"./assets/step-1.svg": 5617,
	"./compras/Compras": 538,
	"./compras/Compras.vue": 538,
	"./compras/HistoricoCompras": 8087,
	"./compras/HistoricoCompras.vue": 8087,
	"./compras/ResumenCompras": 3956,
	"./compras/ResumenCompras.vue": 3956,
	"./dashboard/Home": 9268,
	"./dashboard/Home.vue": 9268,
	"./dashboard/admin/ControlFarmacias": 9977,
	"./dashboard/admin/ControlFarmacias.vue": 9977,
	"./dashboard/admin/Descuentos": 9647,
	"./dashboard/admin/Descuentos.vue": 9647,
	"./dashboard/admin/Farmacia": 6968,
	"./dashboard/admin/Farmacia.vue": 6968,
	"./dashboard/admin/Menu": 609,
	"./dashboard/admin/Menu.vue": 609,
	"./dashboard/admin/Proveedor": 8883,
	"./dashboard/admin/Proveedor.vue": 8883,
	"./dashboard/admin/Usuario": 4131,
	"./dashboard/admin/Usuario.vue": 4131,
	"./profile/Profile": 5313,
	"./profile/Profile.vue": 5313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9979;